// extracted by mini-css-extract-plugin
export default {"header":"Header_header__Mw-YK","photo":"Header_photo__hgN10","bio":"Header_bio__aet3k","name":"Header_name__0w15D","about":"Header_about__FpKFN"};